<template>
  <el-dialog
  :visible.sync="value"
  :show-close="false"
  :close-on-click-modal="false"
  :close-on-press-escape="false"
  custom-class="commDialog">
    <div class="container">
      <img src="@/assets/images/dialog_logout.svg" class="icon">
      <span class="outer-content">{{bodyText}}</span>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancel" round>繼續留下</el-button>
        <el-button type="primary" @click="confirm" round>{{confirmBtn}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import auth from "@/util/auth";
import line from "@/util/line"; // Line共用方法

export default {
  name: "Logout",
  props: {
    value: {required: false, type: Boolean, default: false},
  },
  data() {
    return {
      line: {
        isLineApp: line.isLineApp(), //在LineApp下開啟才會為true
        lineChennalUserId: 0, //lineChennalUserId表ID
        lineUserOinUserId: 0,
        botId: "",
        lineUserId: "",
      },
      bodyText: line.isLineApp() ? "忍心解除綁定嗎?" : "忍心登出嗎?",
      cancelBtn: line.isLineApp() ? "繼續留下" : "繼續留下",
      confirmBtn: line.isLineApp() ? "解除綁定" : "登出",
    }
  },
  created() {

  },
  mounted() {
    
  },
  methods: {
    cancel: function() {
      this.$emit('close', false);
      this.$root.$emit('isLogout', false);
    },
    confirm: function () {
      if (this.line.isLineApp) {
          let lineObject = line.getLineToken();
          if (lineObject !== "") {
              this.line.lineChennalUserId = lineObject.lineChennalUserId;
              this.line.botId = lineObject.botId
              this.line.lineUserId = lineObject.lineUserId
          }
      }
      this.$http.fetchWithAuthEncrypt`SignOut${{
           'token': auth.getAdminToken(),
           'isLineApp': this.line.isLineApp,
           'lineChennalUserId': this.line.lineChennalUserId,
           'linebotId': this.line.botId,
           'lineUserId': this.line.lineUserId,
      }} ${json => {
           this.$auth.clearToken();
           this.$emit('close', false);
           this.$root.$emit('isLogout', true);
      }}`;
    },
  }
}
</script>

